export default "__VITE_ASSET__BwUaLQKT__"